export const ApiEndPoint = {
  USERS: `users/`,
  QM_EXTERNAL_CANCELLED: "qm_external_cancelled",
  QM_NT_EXTERNAL: "qm_nt_external",
  QM_NT_NOTIFICATION: "qm_nt_notification",
  QM_PM_LIST: "qm_pm_list",
  QM_SC_AVAILABILITY: "qm_sc_availability",
  QM_SC_BLOCKED_SLOTS: "qm_sc_blocked_slots",
  QM_SC_FIELDS: "qm_sc_fields",
  QM_SC_NOTICE_BOARD: "qm_sc_notice_board",
  QM_SC_PATIENT_RECORD: "qm_sc_patient_record",
  QM_SC_PERSONA: "qm_sc_persona",
  QM_SC_SLOT_TYPE: "qm_sc_slot_type",
  QM_SC_SLOTS: "bookings/",
  QM_SC_USERS_PERSONAL_DETAILS: "qm_sc_users_personal_details",
  QM_SC_VISIBILITY: "qm_sc_visibility",
  QM_SC_WALKIN_SLOTS: "qm_sc_walkin_slots",
  QP_CM_DOSAGE: "master_data/medicine_data/",
  QP_CM_FREQUENCY: "master_data/medicine_data/",
  QP_CM_CONSULTATION_DATA: "consultation/",
  QP_CM_GENERIC_NAME: "master_data/medicine_data/",
  QP_CM_LANGUAGE: "master_data/medicine_data/",
  QP_CM_MEDICINE_DATA: "master_data/medicine_data/",
  QP_CM_RX_GROUP: "clinics/",
  QP_CM_SALUTATION: "qp_cm_salutation",
  QP_CM_TAG_TYPES: "master_data/medicine_data/",
  QP_CM_TAGS: "master_data/medicine_data/",
  QP_CM_TEMPLATES: "qp_cm_templates",
  QP_CM_TIMING: "qp_cm_timing",
  QP_CM_UNITS: "master_data/medicine_data/",
  QP_CM_WHEN: "master_data/medicine_data/",
  BHP_REGISTERED_CLINIC: "bhp_registered_clinic",
  QM_SC_ONLINE_APPOINTMENT_DETAILS: "qm_sc_online_appointment_details",
  QP_CM_ALLERGIES: "master_data/medicine_data/",
  QP_CM_DOCTOR_SETTING: "qp_cm_doctor_setting",
  QP_CM_MEDICINE_CATEGORY: "master_data/medicine_data/",
  QP_CM_MEDICINE_TYPE: "master_data/medicine_data/",
  QP_CM_NOTES: "master_data/medicine_data/",
  QP_CM_NOTE_VALUES: "qp_cm_note_values",
  QP_CM_PATIENT_HISTORY: "master_data/medicine_data/",
  QP_CM_TAG_GROUPS: "clinics/",
  QP_CM_VITAL_TYPE: "clinics/",
  QP_CM_VITALS: "qp_cm_vitals",
  SEARCH_MEDICINE_DATA: "master_data/name_medicine/",
  MEDICINE_DATA: "master_data/medicine_data/",
  CLINIC_SERVICES: "payments/billing/",
  INSTITUTION_CUSTOMERS: "payments/billing/",
  CLINIC_PACKAGES: "payments/billing/",
  NUMBER_SEQUENCE: "clinics/",
  NO_SEQ_TRANSACTION_TYPE: "clinics/",
  PAYMENT_TERMS: "payments/billing/",
  BILLING_CREDIT_INVOICE: "payments/billing/",
  PAYMENT_OPTIONS: "payments/billing/",
  BILLING_PAYMENT_VOUCHER: "payments/billing/",
  ADVICES: "consultation/",
  CONSULTATION: "consultation/",
  SERVICE_PKG_SEARCH: "payments/billing/",
  CLINIC: "clinics/",
  BOOKING: "bookings/",
  IPD: "ipds/",
  TRANSLATION: "master_data/translation/",
  CUSTOM_FIELDS: "clinics/custom_fields_value/",
  MEDICINE_TAG_DATA: "master_data/medicine_data/",
  INVENTORY: "inventory/",
  SUBSCRIPTIONS: "subscriptions/",
  DASHBOARD: "dashboard/",
  NOTIFICATION: "notifications/",
  ALL_CERTIFICATES: "users/get_certificates/",
  LOGS: "logs/",
  PHARMACY: "pharmacy/",
  PHARMACY_STATISTICS: "pharmacy/pharmacy_statistics/",
  PHARMACY_ONBOARDING: "users/on_board_pharmacy/",
  PAYMENTS_BILLING: "payments/billing/",
  USERS_SEARCH: "users/user_search/",
  SMART_SCANNER: "ai/upload/",
};
